import CanvasCore from './core';
import LayerPlugin from './plugin/LayerPlugin';

export default (canvas, store) => {
  const editor = new CanvasCore(canvas);
  editor.use(LayerPlugin, { store });
  editor.init();
};
